function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _objectSpread({
        viewBox: "0 0 24 24"
    }, props, {
        children: /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13.4546 10.4002H15.4201V15.6511C15.4201 20.6695 20.1553 21.3075 22.5975 21.3075C23.4314 21.3075 23.9973 21.2207 23.9973 21.2207V16.8694C23.9973 16.8694 23.7293 16.8979 23.3118 16.8979C22.329 16.8979 20.5728 16.6661 20.5728 14.984V10.4842H23.9999V6.48419H20.5728V2.19055H15.5691V6.48417H13.4546V10.4002ZM2.52469 15.9414C2.52469 15.9414 4.2223 17.4499 6.42657 17.4499C7.20059 17.4499 7.94532 17.2465 7.94532 16.7536C7.94532 16.3083 7.11036 15.9979 6.01001 15.589C3.88422 14.7989 0.767884 13.6406 0.767884 10.4295C0.767884 7.61519 3.53739 5.87482 7.08156 5.87482C10.655 5.87482 12.4723 7.58605 12.4723 7.58605L10.7148 11.1548C10.7148 11.1548 9.226 9.93588 7.08156 9.93588C6.30754 9.93588 5.56282 10.1393 5.56282 10.6613C5.56282 11.0308 6.32788 11.2981 7.35845 11.6582C9.48443 12.4011 12.7403 13.5387 12.7403 16.7821C12.7403 19.3354 10.417 21.511 6.4565 21.511C2.61443 21.511 0.321045 19.3062 0.321045 19.3062L2.52469 15.9414Z"
        })
    }));
};
export default Icon;
